"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ToolbarSecondaryGroup = ({ children }) => (react_1.default.createElement(react_core_1.ToolbarGroup, { align: { md: 'alignRight' } }, children));
exports.default = ToolbarSecondaryGroup;
//# sourceMappingURL=ToolbarSecondaryGroup.js.map